import store from '@/store'
import mutationTypes from '@/store/mutationTypes'

export default {
  async getSupplier(isHideUnusedSupplier = 0) {
    const suppliers = await store.dispatch('Supplier/getSuppliersFromApi', {
      isHideUnusedSupplier: isHideUnusedSupplier
    })
    if (!suppliers) {
      // API実行失敗
      return {}
    }

    const supplierIdNameList = suppliers.data.map((ele) => {
      return { label: ele.name, value: ele.supplierId }
    })
    const supplierIdNameAndDescriptionList = suppliers.data.map((ele) => {
      let name = ele.description
        ? ele.name + '【 ' + ele.description + ' 】'
        : ele.name
      return {
        label: name,
        value: ele.supplierId
      }
    })

    store.commit(
      `Supplier/${mutationTypes.SUPPLIER_SET_SUPPLIER_ID_NAME_LIST}`,
      supplierIdNameList
    )
    store.commit(
      `Supplier/${mutationTypes.SUPPLIER_SET_SUPPLIER_ID_NAME_AND_DESCRIPTION_LIST}`,
      supplierIdNameAndDescriptionList
    )

    return suppliers
  },

  getSupplierNameById(id) {
    return this.getSupplierBySupplierId(id).name
  },
  getSupplierBySupplierId(id) {
    const supplierList = store.getters['Supplier/getSuppliersFromState']
    const ret = supplierList.find((v) => v.supplierId === id)
    return ret
  },
  async getSupplierIdNameList() {
    const suppliers = await store.dispatch('Supplier/getSuppliersFromApi')
    // API実行失敗
    if (!suppliers) {
      return {}
    }
    const supplierIdNameList = suppliers.data.map((ele) => {
      return { label: ele.name, value: ele.supplierId }
    })
    return {
      code: suppliers.code,
      message: suppliers.message,
      data: supplierIdNameList
    }
  },
  getSupplierDisplayName(supplier) {
    if (!supplier) {
      return '-'
    }

    const description = supplier.description
      ? `【${supplier.description}】`
      : ''
    return supplier.name + description
  }
}
